import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const testInstructors = [
  {
    firstName: "Arben",
    lastName: "Krasniqi",
    phoneNumber: "+383 44 123 456",
    email: "arben.krasniqi@autoshkolla.com",
    personalNumber: "1234567890",
    username: "arbenkr",
    password: "AK7890",
    birthday: "1985-03-15",
    gender: "male",
    experience: "12",
    instructorType: "Both",
    categoryLicenses: ["B", "C", "D"],
    vehicleType: "School",
    address: "Rr. UCK, Nr. 45, Prishtinë",
    notes: "Experienced instructor with excellent teaching skills",
    status: "active",
  },
  {
    firstName: "Afërdita",
    lastName: "Hoxha",
    phoneNumber: "+383 49 234 567",
    email: "aferdita.hoxha@autoshkolla.com",
    personalNumber: "2345678901",
    username: "aferditah",
    password: "AH8901",
    birthday: "1990-07-22",
    gender: "female",
    experience: "8",
    instructorType: "Theory Instructor",
    categoryLicenses: ["B", "BE"],
    vehicleType: "School",
    address: "Rr. Nënë Tereza, Nr. 12, Prizren",
    notes: "Specializes in theory classes and exam preparation",
    status: "active",
  },
  {
    firstName: "Driton",
    lastName: "Berisha",
    phoneNumber: "+383 45 345 678",
    email: "driton.berisha@autoshkolla.com",
    personalNumber: "3456789012",
    username: "dritonb",
    password: "DB9012",
    birthday: "1988-11-30",
    gender: "male",
    experience: "10",
    instructorType: "Practical Instructor",
    categoryLicenses: ["A", "A1", "A2", "B"],
    vehicleType: "Own",
    address: "Rr. Fehmi Agani, Nr. 78, Pejë",
    notes: "Motorcycle specialist with own training vehicles",
    status: "active",
  },
  {
    firstName: "Besarta",
    lastName: "Mustafa",
    phoneNumber: "+383 44 456 789",
    email: "besarta.mustafa@autoshkolla.com",
    personalNumber: "4567890123",
    username: "besartam",
    password: "BM0123",
    birthday: "1992-05-18",
    gender: "female",
    experience: "6",
    instructorType: "Practical Instructor",
    categoryLicenses: ["B", "B1"],
    vehicleType: "School",
    address: "Rr. Skënderbeu, Nr. 23, Gjakovë",
    notes: "",
    status: "active",
  },
  {
    firstName: "Flamur",
    lastName: "Gashi",
    phoneNumber: "+383 49 567 890",
    email: "flamur.gashi@autoshkolla.com",
    personalNumber: "5678901234",
    username: "flamurg",
    password: "FG1234",
    birthday: "1983-09-12",
    gender: "male",
    experience: "15",
    instructorType: "Both",
    categoryLicenses: ["B", "C", "CE", "D", "DE"],
    vehicleType: "School",
    address: "Rr. Bill Clinton, Nr. 56, Prishtinë",
    notes: "Senior instructor, trains other instructors",
    status: "active",
  },
  {
    firstName: "Shqipe",
    lastName: "Demolli",
    phoneNumber: "+383 45 678 901",
    email: "shqipe.demolli@autoshkolla.com",
    personalNumber: "6789012345",
    username: "shqiped",
    password: "SD2345",
    birthday: "1995-02-28",
    gender: "female",
    experience: "4",
    instructorType: "Theory Instructor",
    categoryLicenses: ["B"],
    vehicleType: "School",
    address: "Rr. Dëshmorët, Nr. 34, Mitrovicë",
    notes: "Young instructor with fresh teaching methods",
    status: "active",
  },
  {
    firstName: "Agron",
    lastName: "Shala",
    phoneNumber: "+383 44 789 012",
    email: "",
    personalNumber: "7890123456",
    username: "agronsh",
    password: "AS3456",
    birthday: "1987-06-05",
    gender: "male",
    experience: "11",
    instructorType: "Practical Instructor",
    categoryLicenses: ["B", "C", "C1"],
    vehicleType: "Own",
    address: "Rr. Lidhja e Prizrenit, Nr. 89, Vushtrri",
    notes: "Truck training specialist",
    status: "active",
  },
  {
    firstName: "Linda",
    lastName: "Hyseni",
    phoneNumber: "+383 49 890 123",
    email: "linda.hyseni@autoshkolla.com",
    personalNumber: "8901234567",
    username: "lindah",
    password: "LH4567",
    birthday: "1991-12-14",
    gender: "female",
    experience: "7",
    instructorType: "Both",
    categoryLicenses: ["B", "BE"],
    vehicleType: "School",
    address: "",
    notes: "Bilingual - teaches in Albanian and English",
    status: "active",
  },
  {
    firstName: "Burim",
    lastName: "Morina",
    phoneNumber: "+383 45 901 234",
    email: "burim.morina@autoshkolla.com",
    personalNumber: "9012345678",
    username: "burimm",
    password: "BM5678",
    birthday: "1986-08-20",
    gender: "male",
    experience: "13",
    instructorType: "Practical Instructor",
    categoryLicenses: ["A", "B", "C"],
    vehicleType: "School",
    address: "Rr. Ismail Qemali, Nr. 67, Ferizaj",
    notes: "",
    status: "inactive",
  },
  {
    firstName: "Fitore",
    lastName: "Rama",
    phoneNumber: "+383 44 012 345",
    email: "fitore.rama@autoshkolla.com",
    personalNumber: "0123456789",
    username: "fitorer",
    password: "FR6789",
    birthday: "1994-04-09",
    gender: "female",
    experience: "5",
    instructorType: "Theory Instructor",
    categoryLicenses: ["B", "C"],
    vehicleType: "School",
    address: "Rr. Zahir Pajaziti, Nr. 45, Gjilan",
    notes: "Expert in traffic law and regulations",
    status: "active",
  },
  {
    firstName: "Mentor",
    lastName: "Shabani",
    phoneNumber: "+383 49 123 456",
    email: "",
    personalNumber: "1122334455",
    username: "mentorsh",
    password: "MS4455",
    birthday: "1989-10-03",
    gender: "male",
    experience: "9",
    instructorType: "Practical Instructor",
    categoryLicenses: ["B", "D", "D1"],
    vehicleType: "School",
    address: "Rr. Adem Jashari, Nr. 12, Prishtinë",
    notes: "Bus driving instructor",
    status: "active",
  },
  {
    firstName: "Teuta",
    lastName: "Kelmendi",
    phoneNumber: "+383 45 234 567",
    email: "teuta.kelmendi@autoshkolla.com",
    personalNumber: "2233445566",
    username: "teutak",
    password: "TK5566",
    birthday: "1993-01-25",
    gender: "female",
    experience: "6",
    instructorType: "Both",
    categoryLicenses: ["B"],
    vehicleType: "Own",
    address: "Rr. Xhelal Hajda, Nr. 90, Suharekë",
    notes: "Patient instructor, great with nervous students",
    status: "active",
  },
  {
    firstName: "Valmir",
    lastName: "Tahiri",
    phoneNumber: "+383 44 345 678",
    email: "valmir.tahiri@autoshkolla.com",
    personalNumber: "3344556677",
    username: "valmirt",
    password: "VT6677",
    birthday: "1984-07-16",
    gender: "male",
    experience: "14",
    instructorType: "Practical Instructor",
    categoryLicenses: ["B", "C", "CE", "D", "DE"],
    vehicleType: "School",
    address: "Rr. Ukshin Hoti, Nr. 34, Deçan",
    notes: "All categories instructor, most experienced",
    status: "active",
  },
  {
    firstName: "Mimoza",
    lastName: "Limani",
    phoneNumber: "+383 49 456 789",
    email: "mimoza.limani@autoshkolla.com",
    personalNumber: "4455667788",
    username: "mimozal",
    password: "ML7788",
    birthday: "1996-03-07",
    gender: "female",
    experience: "3",
    instructorType: "Theory Instructor",
    categoryLicenses: ["B"],
    vehicleType: "School",
    address: "",
    notes: "New instructor, recently certified",
    status: "active",
  },
  {
    firstName: "Luan",
    lastName: "Vitija",
    phoneNumber: "+383 45 567 890",
    email: "",
    personalNumber: "5566778899",
    username: "luanv",
    password: "LV8899",
    birthday: "1990-11-19",
    gender: "male",
    experience: "8",
    instructorType: "Both",
    categoryLicenses: ["A", "A1", "A2", "B", "BE"],
    vehicleType: "Own",
    address: "Rr. Bajram Kelmendi, Nr. 23, Klinë",
    notes: "Motorcycle and car instructor",
    status: "inactive",
  },
  {
    firstName: "Drita",
    lastName: "Kastrati",
    phoneNumber: "+383 44 678 901",
    email: "drita.kastrati@autoshkolla.com",
    personalNumber: "6677889900",
    username: "dritak",
    password: "DK9900",
    birthday: "1988-05-31",
    gender: "female",
    experience: "10",
    instructorType: "Practical Instructor",
    categoryLicenses: ["B", "C"],
    vehicleType: "School",
    address: "Rr. Mbretëresha Teutë, Nr. 56, Prishtinë",
    notes: "High pass rate, excellent practical skills",
    status: "active",
  },
  {
    firstName: "Ramiz",
    lastName: "Dervishi",
    phoneNumber: "+383 49 789 012",
    email: "ramiz.dervishi@autoshkolla.com",
    personalNumber: "7788990011",
    username: "ramizd",
    password: "RD0011",
    birthday: "1982-09-23",
    gender: "male",
    experience: "16",
    instructorType: "Both",
    categoryLicenses: ["B", "C", "C1", "D", "D1"],
    vehicleType: "School",
    address: "Rr. Garibaldi, Nr. 78, Prizren",
    notes: "Veteran instructor, training since 2007",
    status: "active",
  },
  {
    firstName: "Njomza",
    lastName: "Rexhepi",
    phoneNumber: "+383 45 890 123",
    email: "njomza.rexhepi@autoshkolla.com",
    personalNumber: "8899001122",
    username: "njomzar",
    password: "NR1122",
    birthday: "1997-02-11",
    gender: "female",
    experience: "2",
    instructorType: "Theory Instructor",
    categoryLicenses: ["B"],
    vehicleType: "School",
    address: "Rr. Elez Berisha, Nr. 45, Istog",
    notes: "",
    status: "active",
  },
  {
    firstName: "Shkëlzen",
    lastName: "Osmani",
    phoneNumber: "+383 44 901 234",
    email: "",
    personalNumber: "9900112233",
    username: "shkelzeno",
    password: "SO2233",
    birthday: "1991-08-04",
    gender: "male",
    experience: "7",
    instructorType: "Practical Instructor",
    categoryLicenses: ["B", "BE", "C"],
    vehicleType: "Own",
    address: "Rr. Hasan Prishtina, Nr. 12, Rahovec",
    notes: "Specializes in defensive driving techniques",
    status: "active",
  },
  {
    firstName: "Arlinda",
    lastName: "Sylejmani",
    phoneNumber: "+383 49 012 345",
    email: "arlinda.sylejmani@autoshkolla.com",
    personalNumber: "0011223344",
    username: "arlindas",
    password: "AS3344",
    birthday: "1995-12-28",
    gender: "female",
    experience: "4",
    instructorType: "Both",
    categoryLicenses: ["B", "C"],
    vehicleType: "School",
    address: "Rr. Agim Ramadani, Nr. 67, Malishevë",
    notes: "Very patient with beginner drivers",
    status: "active",
  },
];

export const createTestInstructors = async () => {
  try {
    console.log("Starting to create test instructors...");

    const instructorsRef = collection(db, "instructors");
    let successCount = 0;

    for (const instructor of testInstructors) {
      try {
        await addDoc(instructorsRef, {
          ...instructor,
          createdAt: serverTimestamp(),
        });
        successCount++;
        console.log(
          `✓ Created instructor: ${instructor.firstName} ${instructor.lastName}`
        );
      } catch (error) {
        console.error(
          `✗ Failed to create ${instructor.firstName} ${instructor.lastName}:`,
          error
        );
      }
    }

    console.log(
      `\n✅ Successfully created ${successCount} out of ${testInstructors.length} instructors!`
    );
    return { success: true, count: successCount };
  } catch (error) {
    console.error("Error creating test instructors:", error);
    return { success: false, error };
  }
};

export default createTestInstructors;
